import axios from 'axios';
import { useEffect, useState } from 'react'
import { RiArrowDownSLine } from "react-icons/ri";
import { toast } from 'react-toastify';
import PaginationComponent from '../../../../utils/PaginationComponent';
import searchIcon from "../../../../assets/admin/search.svg";
import { useParams } from 'react-router-dom';
import TableLoader from '../../../../utils/TableLoader';
import { sanitizeText } from '../../../../utils/TextUtils';
import { IoClose } from 'react-icons/io5';
import { TiTick } from 'react-icons/ti';
import MasterWineListAdd from './MasterWineListAdd';
import StockWineListAdd from './StockWineListAdd';
import WineListTimeSlotAdd from './WineListTimeSlotAdd';

const WineListAdd = (props) => {
  const {
    totalPages,
    rowsPerPage,
    setRowsPerPage,
    page,
    setPage,
    wineData,
    setWineData,
    wineStockAvailable,
    setWineStockAvailable,
    getWineData,
    getWineListData,
    isLoading,
    setIsLoading,
    setAddWineList,
    searchWine,
    setSearchWine,
    handleSearchChange,

  } = props;

  const apiUrl = import.meta.env.VITE_METERI_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [wineFormData, setWineFormData] = useState({
    name: "",
    description: "",
    is_show_filter: 1,
    is_show_sentence: 1
  });

  const [toggleStatus, setToggleStatus] = useState();
  const [statusValue, setStatusValue] = useState("");
  const [timeSlots, setTimeSlots] = useState({});
  const [selectedWine, setSelectedWine] = useState([]);
  const [userType, setUserType] = useState('');

  useEffect(() => {
    const role = localStorage.getItem("Role");
    setUserType(role)
  }, []);

  const [activeDay, setActiveDay] = useState("");
  const { slug2, rest_slug2 } = useParams();
  const states = ["Active", "Inactive"]

  const days = [
    "Lunedì",
    "Martedì",
    "Mercoledì",
    "Giovedì",
    "Venerdì",
    "Sabato",
    "Domenica",
  ];

  const handleAddTimeSlot = (day) => {
    let isValid = true;
    const currentSlots = timeSlots[day] || [];

    if (currentSlots.some((slot) => !slot.start_time || !slot.end_time)) {
      toast.error("Please complete all existing time slots before adding a new one.", { theme: "colored", autoClose: 1000 });
      return;
    }

    for (let i = 0; i < currentSlots.length; i++) {
      const slot = currentSlots[i];
      if (slot.start_time && slot.end_time && slot.start_time >= slot.end_time) {
        toast.error("The end time must be greater than the start time.", { theme: "colored", autoClose: 1000 });
        isValid = false;
        break;
      }
    }

    if (isValid) {
      setTimeSlots((prev) => ({
        ...prev,
        [day]: [...(prev[day] || []), { start_time: "00:00", end_time: "23:59" }],
      }));
    }
  };

  const handleTimeSlotChange = (day, index, field, value) => {
    setTimeSlots((prev) => {
      const updatedSlots = [...(prev[day] || [])];
      updatedSlots[index][field] = value;
      return { ...prev, [day]: updatedSlots };
    });
  };

  const validSlot = () => {
    let isValid = true;

    if (statusValue === "Inactive") {
      return true;
    }

    if (Object.keys(timeSlots).length === 0) {
      toast.error("At least one time slot must be added.", { theme: "colored", autoClose: 1000 });
      return false;
    }

    for (let day in timeSlots) {
      const currentSlots = timeSlots[day];

      if (currentSlots.length === 0) {
        toast.error(`At least one time slot is required for ${day}.`, { theme: "colored", autoClose: 1000 });
        isValid = false;
        break;
      }

      for (let i = 0; i < currentSlots.length; i++) {
        const slot = currentSlots[i];

        if (!slot.start_time || !slot.end_time) {
          toast.error(`Both start and end times are required for ${day}.`, { theme: "colored", autoClose: 1000 });
          isValid = false;
          break;
        }

        if (slot.start_time >= slot.end_time) {
          toast.error(`The end time must be greater than or not equal to the start time  ${day}.`, { theme: "colored", autoClose: 1000 });
          isValid = false;
          break;
        }
      }

      if (!isValid) break;
    }

    return isValid;
  };

  const handleRemoveTimeSlot = (key, index) => {
    setTimeSlots((prev) => {
      if (prev && prev[key] && Array.isArray(prev[key])) {
        const updatedTimeSlots = { ...prev };
        updatedTimeSlots[key] = updatedTimeSlots[key].filter((_, i) => i !== index);
        if (updatedTimeSlots[key].length === 0) {
          delete updatedTimeSlots[key];
        }
        return updatedTimeSlots;
      }
      return prev;
    });
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setWineFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value,
  //   }));
  // };

  const toggleSwitch = (field) => {
    setWineFormData((prev) => ({
      ...prev,
      [field]: prev[field] === 1 ? 0 : 1,
    }));
  };

  const isFormValid = wineFormData.name && selectedWine.length !== 0 && statusValue
  const handleSave = async () => {
    if (statusValue === "") {
      toast.warn("Please select a status.", {
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }

    if (statusValue === "Inactive") {
      toast.warn("Inactive status is not allowed. Please select 'Active'.", {
        autoClose: 1000,
        theme: "colored",
      });
      return;
    }

    if (!validSlot()) {
      return;
    }
    setIsLoading({ ...isLoading, main: true });
    const timeSlotsMap = {
      "monday": "Lunedì",
      "tuesday": "Martedì",
      "wednesday": "Mercoledì",
      "thursday": "Giovedì",
      "friday": "Venerdì",
      "saturday": "Sabato",
      "sunday": "Domenica"
    };

    const filteredTimeSlots = Object.entries(timeSlotsMap).reduce((acc, [key, value]) => {
      if (Array.isArray(timeSlots?.[value]) && timeSlots[value].length > 0) {
        acc[key] = timeSlots[value];
      }
      return acc;
    }, {});

    const wineDataObject = {
      restaurant_id: slug2 ? slug2 : rest_slug2,
      name: wineFormData.name,
      description: wineFormData.description,
      status: statusValue,
      wines: selectedWine,
      time_slots: filteredTimeSlots,
      is_show_filter: wineFormData.is_show_filter || 0,
      is_show_sentence: wineFormData.is_show_sentence || 0,
      price_type_filter: "bottle_price",
      price_filter: "asc",
    };

    try {
      const response = await axios.post(`${apiUrl}/api/v1/winelists`, wineDataObject, {
        headers: { Authorization: `Bearer ${token}` },
      });
      getWineListData();
      toast.success(response?.data?.message || 'Wines added successfully!', {
        theme: 'colored',
        autoClose: 1000,
      });
    } catch (error) {
      const errors = error?.response?.data?.errors;
      if (errors) {
        for (const key in errors) {
          if (Array.isArray(errors[key])) {
            errors[key].forEach((message) => {
              toast.error(message, {
                theme: "colored",
                autoClose: 3000,
              });
            });
          }
        }
      } else {
        toast.error(error?.response?.data?.message, {
          theme: "colored",
          autoClose: 3000,
        });
      }
    } finally {
      setIsLoading({ ...isLoading, main: false });
      setAddWineList(false);
      setStatusValue("");
      setSelectedWine([]);
    }
  };

  const handleCancel = () => {
    setAddWineList(false)
    setSelectedWine([])
    // setToggleStatus(false)
    setTimeSlots({})
    setActiveDay("")
    setSearchWine("")
    setPage(1)
    setWineStockAvailable(true)
  }

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (!event.target.closest(".dropdown-container")) {
        setToggleStatus(false)
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return (
    <>
      <section>
        <div className="flex lg:flex-row flex-col justify-between gap-3">
          <h3 className="text-3xl font-bold mb-2 poppins-medium self-start">Creazione Carta Vini</h3>
          <div className='flex items-center justify-end gap-3 ml-auto'>
            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={wineFormData.is_show_filter === 1}
                onChange={() => toggleSwitch("is_show_filter")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                        peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                        after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                        after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {wineFormData.is_show_filter ? "Mostra Filtri" : "Nascondi filtri"}
            </span>
            <label className="cursor-pointer">
              <input
                type="checkbox"
                checked={wineFormData.is_show_sentence === 1}
                onChange={() => toggleSwitch("is_show_sentence")}
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-gray-200 peer-focus:outline-none rounded-full
                        peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full
                        after:absolute after:top-[2px] after:start-[2px] after:bg-white after:h-4 after:w-4 after:rounded-full 
                        after:transition-all peer-checked:bg-[#8B2433]">
              </div>
            </label>
            <span className="text-sm font-medium poppins-regular text-left">
              {wineFormData.is_show_sentence ? "Mostra Presentazione" : "Nascondi presentazione"}
            </span>
          </div>
        </div>

        <div className="w-full flex items-center my-5 justify-center flex-wrap">
          <div className="w-full grid md:grid-cols-2 sm:gap-4 gap-1 mb-[18px]">
            <div className="dropdown-main mb-3">
              <div className="relative group w-full bg-[#FFFFFF]">
                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                  Titolo Carta Vini<span className="text-red-500">*</span>:
                </label>
                <input
                  type="text"
                  placeholder="Titolo della carta dei vini"
                  className="w-full flex justify-between poppins-medium items-center px-4 py-[17px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] relative z-10 poppins-regular text-xs bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(wineFormData.name || "")}
                  onChange={(e) => setWineFormData({ ...wineFormData, name: e.target.value })}
                />
              </div>
            </div>

            <div className="dropdown-main">
              <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block mb-[12px]">
                Stato:
              </label>
              <div className="relative group w-auto bg-[#FFFFFF] dropdown-container">
                <div className="border border-[#777777] rounded-[28px]">
                  <button
                    className="w-full flex justify-between poppins-medium items-center px-4 py-[15px] sm:text-sm text-[13px] text-[#8B8B8B] rounded-[28px] cursor-pointer relative z-10 poppins-regular text-xs bg-transparent  focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                    onClick={() => setToggleStatus(!toggleStatus)}
                  >
                    <span className="mr-2 flex items-center gap-3 poppins-medium">
                      {statusValue === "Active" ? "Attivo" : statusValue === "Inactive" ? "Inattivo" : "Scegli Stato"}
                    </span>
                    <RiArrowDownSLine
                      className={`transform transition-transform duration-300 ${toggleStatus ? "rotate-180" : ""
                        }`}
                      size={"24px"}
                      color="#9f414f"
                    />
                  </button>
                  <div
                    className={`${toggleStatus ? "max-h-60 opacity-100 relative" : "max-h-0 opacity-0 overflow-hidden"
                      } bg-[#FFFFFF] rounded-[28px] absolute top-0 p-2 px-4 mt-0 shadow-lg text-[#DB7685] space-y-1 w-full transition-all duration-300 ease-in-out`}
                  >
                    {states
                      .filter((states) => states !== statusValue)
                      .map((states, index, array) => (
                        <label
                          key={states}
                          className={`${index !== array.length - 1 ? "border-b border-[#8b24331f]" : ""} px-0 py-2 cursor-pointer flex justify-between flex-row gap-[15px] filter_list_btn`}
                          onClick={() => { setStatusValue(states); setToggleStatus(false) }}
                        >
                          <span className="text-xs text-[#8B8B8B] rounded-md flex items-center gap-3 poppins-regular">
                            {states === "Active" ? "Attivo" : states === "Inactive" ? "Inattivo" : ""}
                          </span>
                        </label>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full grid gap-4">
            <div className="relative group w-full bg-[#FFFFFF]">
              <div className="flex flex-col w-full sm:gap-3 gap-1">
                <label className="text-[18px] leading-[27px] font-normal poppins-medium text-[#404040] block pb-[12px]">
                  Descrizione:
                </label>
                <textarea
                  rows="4"
                  className="poppins-regular px-4 py-3 text-[16px] text-[#8B8B8B] rounded-[14px] bg-transparent border border-[#777777] focus:outline-none focus:border-[#d5d6d9] focus:bg-[#f6efef]"
                  value={sanitizeText(wineFormData.description || "")}
                  onChange={(e) => setWineFormData({ ...wineFormData, description: e.target.value })}
                  placeholder="Descrizione della carta dei vini"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <WineListTimeSlotAdd
            days={days}
            activeDay={activeDay}
            statusValue={statusValue}
            setStatusValue={setStatusValue}
            setActiveDay={setActiveDay}
            timeSlots={timeSlots}
            setTimeSlots={setTimeSlots}
            handleTimeSlotChange={handleTimeSlotChange}
            handleAddTimeSlot={handleAddTimeSlot}
            handleRemoveTimeSlot={handleRemoveTimeSlot}
          />
        </div>
      </section>
      <section>
        {/* toggle of wines */}
        <div className="my-5 dark:border-gray-700">
          <div className="flex items-center justify-between lg:flex-row flex-col gap-3">
            <ul className="flex flex-wrap -mb-px text-sm font-medium text-center self-start" id="default-tab" data-tabs-toggle="#default-tab-content" role="tablist">
              <li className="me-2" role="presentation">
                <button
                  className={`inline-block p-4 ${wineStockAvailable && "border-b-4 border-[#8A2533]"} rounded-t-lg hover:text-gray-600 hover:border-[#8A2533]`} id="profile-tab" data-tabs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false"
                  onClick={() => { setWineStockAvailable(true); setSearchWine(""); setPage(1) }}
                >
                  Scorta di vino
                </button>
              </li>
              {userType === "admin" ? (
                <li className="me-2" role="presentation">
                  <button
                    className={`inline-block p-4 ${!wineStockAvailable && "border-b-4 border-[#8A2533]"} rounded-t-lg hover:text-gray-600 hover:border-[#8A2533]`} id="dashboard-tab" data-tabs-target="#dashboard" type="button" role="tab" aria-controls="dashboard" aria-selected="false"
                    onClick={() => { setWineStockAvailable(false); setSearchWine(""); setPage(1) }}
                  >
                    Lista dei vini
                  </button>
                </li>
              ) : (null)}
            </ul>
            <div className="input-type">
              <div className="relative group xl:w-[400px]">
                <button
                  className="inline-flex h-full justify-between items-center w-full px-6 pl-8 py-2 outline-none text-[#8F8F8F] border border-[#D9D9D9] rounded-full shadow-sm"
                >
                  <input
                    type="text"
                    placeholder="Cerca vino"
                    className="text-[#8F8F8F] outline-none pl-4 poppins-medium relative w-full h-full"
                    value={searchWine || ""}
                    onChange={handleSearchChange}
                  />
                  <img
                    src={searchIcon}
                    className="absolute left-4 top-0 bottom-0 my-auto h-4 w-4"
                    alt="Search"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* wines list */}
        <div id="default-tab-content" className="overflow-auto">
          <div
            className="p-4 xl:w-full sm:w-[1500px] w-full bg-[#F8F8F8] border-[1.5px] border-[#8B24332B] rounded-xl shadow"
            id="dashboard"
            role="tabpanel"
            aria-labelledby="dashboard-tab"
          >
            <table className="w-full text-left wine_table">
              <thead>
                <tr className="border-b border-[#8B2433]">
                  <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]"></th>
                  <th className="pb-3 pr-2 text-left poppins-medium text-[#6B6B6B]">
                    Immagine
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nome{" "}
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Tipologia
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Nazione
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Prezzo Pagato (Iva Esclusa)
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Prezzo Calice (Iva Inclusa)
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Prezzo Bottiglia (Iva Inclusa)
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Mostra Prezzi
                  </th>
                  <th className="pb-3 px-2 text-left poppins-medium text-[#6B6B6B]">
                    Quantità
                  </th>
                </tr>
              </thead>
              {isLoading?.main ? (
                <TableLoader />
              ) : (
                wineStockAvailable ?
                  <StockWineListAdd
                    wineData={wineData}
                    setWineData={setWineData}
                    setSelectedWine={setSelectedWine}
                    selectedWine={selectedWine}
                  />
                  :
                  <MasterWineListAdd
                    wineData={wineData}
                    setWineData={setWineData}
                    setSelectedWine={setSelectedWine}
                    selectedWine={selectedWine}
                  />
              )}
            </table>
          </div>
          {wineData && wineData?.length > 0 && (
            <PaginationComponent
              page={page}
              totalPages={totalPages}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
            />
          )}
        </div>

        <div className="mt-8 flex sm:flex-row flex-col px-5 justify-start gap-5 w-full items-center">
          {isLoading?.main ? (
            <button disabled type="button"
              className="sm:w-[120px] w-full poppins-regular justify-center flex items-center space-x-2 p-1 px-3 bg-[#8A2533] text-white border-[1.5px] border-[#d18d97] rounded-lg transition-colors group">
              <svg
                aria-hidden="true"
                className="w-4 h-4 text-gray-50 me-3 animate-spin dark:text-gray-600 fill-[#8B2433] invert"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              Loading...
            </button>
          ) : (
            <button
              disabled={!isFormValid || isLoading?.main}
              // className={(!wineFormData.name || selectedWine.length === 0) ? "bg-blue-200 px-4 py-2  rounded-xl text-white font-bold" : "bg-blue-400 px-4 py-2  rounded-xl text-white font-bold cursor-pointer"}
              className={`sm:w-[120px] w-full flex justify-center items-center space-x-2 p-1 px-3  ${isFormValid && !isLoading?.main ? ' w-[120px] bg-[#8A2533] text-white' : ' w-[120px] bg-gray-300 text-gray-600 cursor-not-allowed'
                } border-[1.5px] border-[#d18d97] bg-[#8A2533] rounded-lg transition-colors group w-[120px]`}
              // className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
              onClick={handleSave}
            // disabled={isLoading.main}
            // onClick={() => {
            //       if (wineFormData.name) {
            //         addWineListData()
            //         setWineStockAvailable(true)
            //         setSearchWine("")
            //       }
            // }}
            >
              <TiTick size={"25px"} color="green" />
              <span className="poppins-regular">Salva</span>
            </button>
          )}
          {/* <button className="flex items-center sm:w-[120px] w-full justify-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={() => {
              setAddWineList(false)
              setSelectedWine([])
              // setToggleStatus(false)
              setTimeSlots({})
              setStatusValue("")
              setActiveDay("")
              setSearchWine("")
              setPage(1)
              setWineStockAvailable(true)
            }}>
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </button> */}

          <button className="sm:w-[120px] w-full justify-center flex items-center space-x-2 p-1 px-3 bg-[#FCFCFC] border-[1.5px] border-[#d18d97] text-red-700 rounded-lg hover:text-gray-50 hover:bg-[#8A2533] transition-colors group"
            onClick={handleCancel}
          >
            <IoClose size={"25px"} color="red" className="group-hover:invert" />
            <span className="poppins-regular">Annulla</span>
          </button>
        </div>
      </section>
    </>
  )
}

export default WineListAdd;